import ButtonLoading from "../../../UI/Button/ButtonLoading";
import InputField from "../../../UI/Form/InputField";
import { EducationalLevel, EducationalSystem } from "../../../Types/Courses";

interface CourseInformationPanelProps {
  title: string;
  slug: string;
  category: string;
  order: number | string;
  description: string;
  educationalSystemId: number | string;
  levelId: number | string;
  isPublished: boolean;
  systems: EducationalSystem[];
  levels: EducationalLevel[];
  titleError?: string;
  educationalSystemError?: string;
  saving: boolean;
  submitLabel: string;
  onTitleChange: (value: string) => void;
  onSlugChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onOrderChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onEducationalSystemChange: (value: string) => void;
  onLevelChange: (value: string) => void;
  onPublishedChange: (value: boolean) => void;
  onSubmit: () => void;
}

export default function CourseInformationPanel(props: CourseInformationPanelProps) {
  const {
    title,
    slug,
    category,
    order,
    description,
    educationalSystemId,
    levelId,
    isPublished,
    systems,
    levels,
    titleError,
    educationalSystemError,
    saving,
    submitLabel,
    onTitleChange,
    onSlugChange,
    onCategoryChange,
    onOrderChange,
    onDescriptionChange,
    onEducationalSystemChange,
    onLevelChange,
    onPublishedChange,
    onSubmit,
  } = props;

  return (
    <section className="bg-white rounded-xl shadow border border-gray-100 p-4 md:p-5">
      <div className="mb-4">
        <h2 className="text-lg font-semibold">Informations du cours</h2>
        <p className="text-xs text-gray-500">
          Commence par les métadonnées du cours avant de construire les unités.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1">
          <label className="text-sm font-medium">Titre</label>
          <InputField value={title} onChange={(event) => onTitleChange(event.target.value)} />
          {titleError ? <p className="text-xs text-red-500">{titleError}</p> : null}
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Slug</label>
          <InputField value={slug} onChange={(event) => onSlugChange(event.target.value)} />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Catégorie</label>
          <InputField value={category} onChange={(event) => onCategoryChange(event.target.value)} />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Ordre</label>
          <InputField
            type="number"
            value={order}
            onChange={(event) => onOrderChange(event.target.value)}
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Système éducatif</label>
          <select
            className="w-full form-select"
            value={educationalSystemId}
            onChange={(event) => onEducationalSystemChange(event.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            {systems.map((system) => (
              <option key={system.id} value={system.id}>
                {system.title}
              </option>
            ))}
          </select>
          {educationalSystemError ? (
            <p className="text-xs text-red-500">{educationalSystemError}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Niveau</label>
          <select
            className="w-full form-select"
            value={levelId}
            onChange={(event) => onLevelChange(event.target.value)}
          >
            <option value="">-- Sélectionner --</option>
            {levels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.title}
              </option>
            ))}
          </select>
        </div>
        <div className="space-y-1 md:col-span-2">
          <label className="text-sm font-medium">Description</label>
          <textarea
            className="w-full form-input"
            rows={4}
            value={description}
            onChange={(event) => onDescriptionChange(event.target.value)}
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium">Statut</label>
          <select
            className="w-full form-select"
            value={isPublished ? "true" : "false"}
            onChange={(event) => onPublishedChange(event.target.value === "true")}
          >
            <option value="false">Brouillon</option>
            <option value="true">Publié</option>
          </select>
        </div>
      </div>

      <div className="flex justify-end mt-4">
        <ButtonLoading loading={saving} label={submitLabel} onClick={onSubmit} />
      </div>
    </section>
  );
}
